import { Typography } from '@mui/material'
import { useTranslate } from 'ra-core'

import { useShowStyles } from '../resources/common/show'

const unorderedListStyle = {
  margin: 16,
  marginTop: 4,
  marginBottom: 0,
  paddingRight: 12,
  textAlign: 'justify',
}

const DefinitionList = ({ items = [] }) => {
  const showClasses = useShowStyles()
  const translate = useTranslate()

  return (
    <ul style={{ ...unorderedListStyle, ...showClasses.unorderedList }}>
      {items.map((i) => (
        <li key={i.role} style={showClasses.unorderedListItem}>
          <Typography
            component="span"
            variant="body2"
            sx={{ fontWeight: 'bold', display: 'inline' }}
            color="textPrimary"
          >
            {translate(i.role)}
          </Typography>{' '}
          <Typography component="span" variant="body2" sx={{ display: 'inline' }} color="textPrimary">
            {translate(i.permission)}
          </Typography>
        </li>
      ))}
    </ul>
  )
}

export default DefinitionList
